export default __webpack_public_path__ + "static/media/QSInfo.a60ad72f.md";